<template>
    <div class="page-content page-content-full">
        <h1>Signed out</h1>
        <p>You are now signed out.</p>
        <button class="button button-primary" @click="signIn">Sign in</button>
    </div>
</template>
<script>
    export default {
        name: 'LogoutView',
        methods: {
            signIn() {
                this.$auth.signInWithRedirect()
            }
        }
    }
</script>
